import {createMsg, getFilterCustomerCount} from 'app-self-support-order/services/group-msg'
import createModel from 'utils/model'

const initState = () => ({
    media: null,
    filterCustomerCount: undefined, // 计算过滤后的群发客户数量
})

export default createModel({
    namespace: 'selfSupportOrder_groupMsg_createMsg',

    state: initState(),

    effects: {
        *createMsg({payload, callback}, {call}) {
            const data = yield call(createMsg, payload)
            if (data) {
                callback && callback(data)
            }
        },

        // 计算过滤后的群发客户数量
        *getFilterCustomerCount({payload}, {call, put}) {
            const res = yield call(getFilterCustomerCount, payload)
            if (res && res.data) {
                yield put({
                    type: 'setProperty',
                    payload: {
                        filterCustomerCount: res.data?.count,
                    },
                })
            }
        },
    },

    reducers: {
        resetState(state) {
            return {...state, ...initState()}
        },
    },
})
